import {
  EditSourceFormAction,
  EditSourceFormActionType,
  SetEditSourceRequestConfigurationAction,
  SetIsLoadingAction,
  SetIsUpdateSourceSucceededAction,
  SetShouldShowErrorsAction,
  SetSourceResourceAction,
  SetUpdateSourceRequestAction,
  SetUpdateSourceResponseAction,
} from "@/pages/sources/components/edit/actions";
import { EditSourceFormState } from "@/pages/sources/components/edit/types";

function setSourceResource(
  state: EditSourceFormState,
  action: SetSourceResourceAction,
): EditSourceFormState {
  return {
    ...state,
    source: action.payload,
  };
}

function setEditSourceRequestConfiguration(
  state: EditSourceFormState,
  action: SetEditSourceRequestConfigurationAction, // eslint-disable-line @typescript-eslint/no-unused-vars
): EditSourceFormState {
  const newState: EditSourceFormState = {
    ...state,
    updateSourceRequest: {
      ...state.updateSourceRequest,
    },
    shouldShowErrors: false,
    isUpdateSourceSucceeded: false,
  };

  return newState;
}

function setUpdateSourceRequest(
  state: EditSourceFormState,
  action: SetUpdateSourceRequestAction,
): EditSourceFormState {
  return {
    ...state,
    updateSourceRequest: action.payload,
  };
}

function setUpdateSourceResponse(
  state: EditSourceFormState,
  action: SetUpdateSourceResponseAction,
): EditSourceFormState {
  return {
    ...state,
    updateSourceResponse: action.payload,
  };
}

function setIsLoading(state: EditSourceFormState, action: SetIsLoadingAction): EditSourceFormState {
  return {
    ...state,
    isLoading: action.payload,
  };
}

function setIsUpdateSourceSucceeded(
  state: EditSourceFormState,
  action: SetIsUpdateSourceSucceededAction,
): EditSourceFormState {
  return {
    ...state,
    isUpdateSourceSucceeded: action.payload,
  };
}

function setShouldShowErrors(
  state: EditSourceFormState,
  action: SetShouldShowErrorsAction,
): EditSourceFormState {
  return {
    ...state,
    shouldShowErrors: action.payload,
  };
}

const createSourceFormReducer = (
  state: EditSourceFormState,
  action: EditSourceFormAction,
): EditSourceFormState => {
  switch (action.type) {
    case EditSourceFormActionType.SET_SOURCE_RESOURCE:
      return setSourceResource(state, action);
    case EditSourceFormActionType.SET_UPDATE_SOURCE_REQUEST:
      return setUpdateSourceRequest(state, action);
    case EditSourceFormActionType.SET_UPDATE_SOURCE_REQUEST_CONFIGURATION:
      return setEditSourceRequestConfiguration(state, action);
    case EditSourceFormActionType.SET_UPDATE_SOURCE_RESPONSE:
      return setUpdateSourceResponse(state, action);
    case EditSourceFormActionType.SET_IS_LOADING:
      return setIsLoading(state, action);
    case EditSourceFormActionType.SET_IS_UPDATE_SOURCE_SUCCEEDED:
      return setIsUpdateSourceSucceeded(state, action);
    case EditSourceFormActionType.SET_SHOULD_SHOW_ERRORS:
      return setShouldShowErrors(state, action);
  }
};

export default createSourceFormReducer;
